<div class="popup-container" [ngStyle]="style" [@visibilityScaleAnimation]="animationState">
    <icon name="x" class="close-icon" (click)="handleClose()"></icon>
    <ng-container #viewContainer class="content"></ng-container>
</div>